module.exports = __webpack_public_path__ + "static/media/coverage.c738ccb9.jpg";